// extracted by mini-css-extract-plugin
export default {"doctorsContainer":"Specialists_doctorsContainer__3Vu8t","card":"Specialists_card__T5QNR","container":"Specialists_container__75qkU"};